export const projectCode = 'um';

export const documentTitle = 'U Mobile - BusinessCare';

export const antd = {
  configProvider: {
    componentSize: 'middle',
  },
  theme: {
    components: {
      Tabs: {
        horizontalItemPadding: '12px 12px',
        itemSelectedColor: '#FF7B00',
        inkBarColor: '#FF7B00',
        itemHoverColor: '#FF7B00',
      },
      Menu: {
        horizontalItemHoverColor: '#FF7B00',
        horizontalItemSelectedColor: '#FF7B00',
      },
      Empty: {
        colorText: 'rgba(0, 0, 0, 0.25)',
      },
    },
    token: {
      colorPrimary: '#FF7B00',
      fontFamily: 'Pragmatica',
      colorLink: '#FF7B00',
    },
  },
};
